import { render } from "./customlayout.vue?vue&type=template&id=624aa9aa"
import script from "./customlayout.vue?vue&type=script&lang=js"
export * from "./customlayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__